import { SPSiteMetadata } from './sp-site-metadata';
export class SharePointWrapper {
    siteURL: string;
    metadataList: SPSiteMetadata[];
}
